"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCTS_MOBILE = exports.PRODUCTS_ANDROID = exports.PRODUCTS_FDR = exports.PRODUCTS_FDR_X_SELL = exports.PRODUCTS_IOS = exports.PRODUCTS_WEB = void 0;
exports.PRODUCTS_WEB = ["touch2", "touch3", "fdrmobile"];
exports.PRODUCTS_IOS = [
    "ios",
    "ios2",
    "fdrios",
    "fdriosxsell",
    "iosnative"
];
exports.PRODUCTS_FDR_X_SELL = ["fdriosxsell", "fdrandroidxsell"];
exports.PRODUCTS_FDR = [
    "fdrmobile",
    "fdrios",
    "fdrandroid",
    ...exports.PRODUCTS_FDR_X_SELL
];
exports.PRODUCTS_ANDROID = [
    "androidnative",
    "fdrandroid",
    "androidwrapper",
    "tvgandroid",
    "fdrandroidxsell",
    "fdrandroidgps"
];
exports.PRODUCTS_MOBILE = [
    ...new Set([
        ...exports.PRODUCTS_WEB,
        ...exports.PRODUCTS_IOS,
        ...exports.PRODUCTS_FDR,
        ...exports.PRODUCTS_ANDROID
    ])
];
/* eslint-disable */
exports.default = (product) => {
    if (typeof window !== "undefined" &&
        window.__TVG_GLOBALS__ &&
        window.__TVG_GLOBALS__.PRODUCT) {
        return window.__TVG_GLOBALS__.PRODUCT;
    }
    return product;
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./node_modules/@tvg/conf/cjs/src/product.js